import * as Yup from "yup";

import { basicEntityFromJson, exhaustiveCheck, IBasicEntity } from "../../../core/models";

export enum EClientType {
  BUYER = "BUYER",
  SELLER = "SELLER",
  WORKER = "WORKER",
}

export function clientTypeToString(type: EClientType): string {
  switch (type) {
    case EClientType.BUYER:
      return "Alıcı";
    case EClientType.SELLER:
      return "Satıcı";
    case EClientType.WORKER:
      return "İşçi";
    default:
      exhaustiveCheck(type);
  }

  return "";
}

export interface IClientType {
  id: string;
  label: string;
}

export const clientTypeOptions = Object.entries(EClientType).map<IClientType>((item) => {
  const [key, value] = item;
  return {
    id: key,
    label: clientTypeToString(value),
  };
});

interface IClientBase {
  name: string;
  balance: number;
  salary: number;
  info: string;
  type: EClientType;
}

export interface IClient extends IClientBase, IBasicEntity {}

export interface IClientForm extends IClientBase {}

const clientCommonValidation = {
  name: Yup.string().required(),
  info: Yup.string(),
  balance: Yup.number().required(),
  salary: Yup.number(),
  type: Yup.mixed()
    .oneOf(Object.values(EClientType))
    .required(),
};

export const clientFormValidation = Yup.object<IClientForm>({
  ...clientCommonValidation,
});

export const clientEditFormValidation = Yup.object<IClientForm>({
  ...clientCommonValidation,
});

export const clientFromJson = (json: any): IClient => {
  const e: IClient = {
    ...basicEntityFromJson(json),
    name: json.name?.toString(),
    balance: parseFloat(json.balance),
    salary: parseFloat(json.salary ?? 0),
    info: json.info?.toString(),
    type: json.type?.toString(),
  };

  return e;
};

export const clientToJson = (form: IClientForm) => {
  return {
    name: form.name.toString(),
    balance: parseFloat(form.balance.toString()),
    salary: parseFloat(form.salary.toString()),
    info: form.info.toString(),
    type: form.type.toString(),
  };
};
